<template>
  <v-container fluid>
    <Title :title="'Magby users'" />
    <v-row align="center" justify="center">
      <v-col cols="11">
        <v-card class="pa-md-4 mx-lg-auto" rounded>
          <v-subheader class="pl-0">Add new user below</v-subheader>
          <v-form ref="form" @submit.prevent="createUser" id="register-form">
            <v-select
              :items="mappedTerminals"
              prepend-icon="important_devices"
              label="Choose terminal"
              v-model="user.terminals"
              multiple
            ></v-select>
            <v-text-field
              label="Login"
              name="login"
              :rules="emailRules"
              prepend-icon="mdi-account"
              type="text"
              v-model="user.email"
            ></v-text-field>
            <v-text-field
              id="password"
              label="Password"
              name="password"
              :rules="passwordRules"
              prepend-icon="mdi-lock"
              type="password"
              v-model="user.password"
            ></v-text-field>
            <v-text-field
              id="commission"
              label="Commission"
              name="commission"
              prepend-icon="account_balance"
              type="text"
              v-model="user.commission"
            ></v-text-field>
            <v-alert dense outlined type="error" v-if="error">
              {{ error }}
            </v-alert>
            <v-alert dense outlined type="success" v-if="success">
              {{ success }}
            </v-alert>
            <v-spacer></v-spacer>
            <v-btn
              style="margin-bottom: 15px"
              width="100%"
              type="submit"
              color="primary"
              form="register-form"
              >Register</v-btn
            >
            <v-spacer></v-spacer>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="11">
        <v-list dense>
          <v-list-item link v-for="(user, index) in users" :key="index">
            <v-list-item-action>
              <v-btn icon>
                <v-icon>{{ "remove_red_eye" }}</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ user.email }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon>
                <v-icon>{{ "delete" }}</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Title from "../components/Title";

export default {
  name: "Users",
  components: {
    Title,
  },
  data: () => ({
    users: [],
    error: "",
    success: "",
    user: {
      email: "",
      password: "",
      terminals: [],
      commission: ""
    },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [(v) => !!v || "Password is required"],
    terminals: [],
  }),
  computed: {
    mappedTerminals() {
      return this.terminals.map((n) => n.name)
    }
  },
  methods: {
    createUser() {
      const user = {
        email: this.user.email,
        password: this.user.password,
        terminals: this.user.terminals,
        commission: parseInt(this.user.commission)
      };
      this.$http
        .post("rest/user/signup", user)
        .then(() => {
          this.getUsers();
          this.$refs.form.reset();
          this.success = "User has been successfully registered";
          this.error = "";
        })
        .catch(() => {
          this.success = "";
          this.error = "Something went wrong";
        });
    },
    getUsers() {
      this.$http.get("rest/user/getUsers").then((res) => {
        this.users = res.data;
      });
    },
  },
  mounted() {
    this.getUsers();

    this.$http.get("rest/terminals").then((res) => {
      this.terminals = res.data;
    });
  },
};
</script>